// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.timestamp__CZ4iKY5quh{flex-grow:1}`, "",{"version":3,"sources":["webpack://./src/app/views/layout/views/conversations/components/table/components/rows/conversationRow/components/rowCells/timestamp/conversationsTableTimestamp.module.scss"],"names":[],"mappings":"AAEA,uBACE,WAAA","sourcesContent":["@import '@dixa/lib-shared-tokens/scss';\n\n.timestamp {\n  flex-grow: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"timestamp": `timestamp__CZ4iKY5quh`
};
export default ___CSS_LOADER_EXPORT___;
